import ActionTypes from '../constants/ActionTypes';

const fetchContentCardDefaults = (pointSystemId) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULTS_FETCH,
  payload: {
    pointSystemId,
  },
});

fetchContentCardDefaults.success = (pointSystemId, items) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULTS_FETCH__SUCCESS,
  payload: {
    pointSystemId,
    items,
  },
});

fetchContentCardDefaults.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULTS_FETCH__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

const updateContentCardDefault = (id, data) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_UPDATE,
  payload: {
    id,
    data,
  },
});

const createContentCardDefault = (pointSystemId, data) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_CREATE,
  payload: {
    pointSystemId,
    data,
  },
});

createContentCardDefault.success = (item) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_CREATE__SUCCESS,
  payload: {
    item,
  },
});

createContentCardDefault.failure = (pointSystemId, error) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_CREATE__FAILURE,
  payload: {
    pointSystemId,
    error,
  },
});

updateContentCardDefault.success = (item) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_UPDATE__SUCCESS,
  payload: {
    item,
  },
});

updateContentCardDefault.failure = (id, error) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_UPDATE__FAILURE,
  payload: {
    id,
    error,
  },
});

const deleteContentCardDefault = (id) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_DELETE,
  payload: {
    id,
  },
});

deleteContentCardDefault.success = (item) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_DELETE__SUCCESS,
  payload: {
    item,
  },
});

deleteContentCardDefault.failure = (id, error) => ({
  type: ActionTypes.CONTENT_CARD_DEFAULT_DELETE__FAILURE,
  payload: {
    id,
    error,
  },
});

export default {
  fetchContentCardDefaults,
  createContentCardDefault,
  updateContentCardDefault,
  deleteContentCardDefault,
};

